import { useIntl } from '@umijs/max'
import { useMemo } from 'react'
import ConfirmModalBtn from '../ConfirmModalBtn'

type Props = {
  resource: string // 资源名称，用于获取国际化文本，例：pages.${resource}.option.create
  id: number | string // 需删除的资源id
  onDelete: () => Promise<void> // 删除资源的方法
}

const DeleteBtn: React.FC<Props> = ({ resource, id, onDelete }) => {
  const intl = useIntl()
  const delText = useMemo(() => {
    return intl.formatMessage({
      id: `pages.${resource}.option.delete`,
    })
  }, [resource])
  return (
    <ConfirmModalBtn
      label={'pages.option.delete'}
      className='del'
      title={delText}
      id={id}
      onFinish={onDelete}
      okType='danger'
    />
  )
}

export default DeleteBtn
